import React from 'react';
import { newBlock } from 'css-classify';
import './addButton.css';

const cls = newBlock('addButton');
export const AddButton = ({ onClick }) => (
  <div className={cls.names('div', 'transparent')} onClick={onClick} >
    <i className="fa fa-plus"></i>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/addButton.js